export default "<div id=\"chart\" echarts [options]=\"chartOption\" class=\"demo-chart\"></div>\r\n";